import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Logo|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogCertLogo';
export type SPCatalogCertLogoLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonUpdate`
	| `${LocNameStart}LabelDownloadEnabled`;

export const spCatalogCertLogoLocs: LocDefs<SPCatalogCertLogoLocNames> = {
	SPCatalogCertLogoTitleTab: {
		defaultValue: 'Credential Logo',
		description: 'Tab title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.Logo.Title.TabTitle',
		...sharedProperties,
	},
	SPCatalogCertLogoTitleSection: {
		defaultValue: 'Logo File',
		description: 'Section title',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.Logo.Title.SectionTitle',
		...sharedProperties,
	},
	SPCatalogCertLogoButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Logo.Button.Cancel',
		...sharedProperties,
	},
	SPCatalogCertLogoButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Logo.Button.Edit',
		...sharedProperties,
	},
	SPCatalogCertLogoButtonUpdate: {
		defaultValue: 'Update',
		description: 'Update button',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Logo.Button.Update',
		...sharedProperties,
	},
	SPCatalogCertLogoLabelDownloadEnabled: {
		defaultValue: 'Logo Download Enabled',
		description: 'Label for: Logo Download Enabled.',
		displayPath: `${pathStart}Logo Download Enabled`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Logo.FieldLabel.DownloadEnabled',
		...sharedProperties,
	},
};

export type SPCatalogCertLogoLocType = LocMap<SPCatalogCertLogoLocNames>;
